import React from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import TermsSection from './TermsSection';
import { useNavigate } from 'react-router-dom';
import SEO from '../../components/common/SEO';

const GeneralTerms = () => {
  const navigate = useNavigate();
  const handleNext = () => {
    navigate('/general-terms/page/2');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const conditionGeneralList = [
    {
      title: 'Seller',
      para: 'The seller is ELIXIR ("We"), a premium honey brand offering Mediterranean honey varieties, headquartered at 6 PLACE DU PRESIDENT THOMAS WOODROW WILSON, 31000 TOULOUSE, registered in the Toulouse Trade and Companies Register under number 979 503 539.',
    },
    {
      title: 'Purpose',
      para: "These general terms and conditions ('GTC') define the conditions applicable to the sale of premium honey products and associated services offered by ELIXIR and the granting of the associated rights to professional and individual clients.",
    },
    {
      title: 'Acceptance',
      para: 'Placing an order with ELIXIR implies full and unconditional acceptance of the GTC by the client, to the exclusion of any other document. Any contrary conditions proposed by the client, unless expressly accepted in writing by us, shall be unenforceable against us.',
    },
    {
      title: 'Order',
      para: "Any order shall be deemed firm and final only after acceptance by us upon receipt of the client's agreement to the issued quotation, by any means (email, mail), or once confirmed in writing by us.",
    },
    {
      title: 'Rates',
      para: 'We reserve the right to modify our rates at any time due to various factors including, but not limited to: euro/dollar or euro/yen exchange rates, changes in raw material costs, transportation costs, or changes in supplier conditions.',
    },
    {
      title: 'Price',
      para: "Prices in effect at the time of the order, expressed in euros, include applicable VAT on the day of the order. Any changes in the VAT rate may be reflected in product or service prices. Prices exclude transport and taxes. All duties, taxes, or other charges under French law or the laws of importing or transit countries are the client's responsibility. Prices on the website may change without notice; only the price at the time of order is binding.",
    },
    {
      title: 'Payment',
      para: 'Payments must be made according to the terms and deadlines stated on the invoice. No payment shall be considered a deposit.',
    },
    {
      title: 'Late Payment',
      para: 'Any amount not paid by the due date shall automatically incur penalties equal to three times the legal interest rate from the day following the due date, without prior notice. A fixed fee of €40 is also due for recovery costs.',
    },
    {
      title: 'Delivery',
      para: "Delivery is made according to the order, either by direct delivery to the client, notice of availability, or delivery to a shipper at the seller's premises. Shipping costs are at the client's expense. Partial deliveries may occur and be invoiced separately.",
    },
    {
      title: 'Delivery Times',
      para: 'Delivery times are approximate and depend on supply availability and transport conditions. Delays shall not justify claims for damages, withholding of payment, or order cancellation. Shipping fees are specified at the time of ordering on our website.',
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="General Terms and Conditions"
        description="Read Elixir's general terms and conditions for the sale of premium Mediterranean honey products. Understand our policies on pricing, delivery, payment, and customer rights."
        keywords="Elixir terms and conditions, honey purchase terms, Mediterranean honey policies, honey delivery terms, honey payment terms, Elixir customer rights"
      />
      <Header />
      <div className="bg-[#f7fbff] py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-[#d4af37] mb-6">
            GENERAL TERMS AND CONDITIONS
          </h1>
          <p className="text-base sm:text-base md:text-xl lg:text-2xl text-[#475467] max-w-3xl mx-auto">
            Welcome to ELIXIR's general terms and conditions. This document outlines how
            we collect, use, and protect your personal data when you use our services.
          </p>
        </div>
      </div>

      <main className="flex-grow bg-white py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <TermsSection title="">
            {conditionGeneralList.map((item, index) => (
              <p className="mt-4" key={index}>
                <b>{item.title} : </b>
                {item.para}
              </p>
            ))}
          </TermsSection>

          <div className="flex justify-center mt-4">
            <button
              onClick={handleNext}
              className="px-6 py-2 bg-[#d4af37] text-black rounded-md hover:bg-yellow-400 transition font-semibold"
            >
              Next Page
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default GeneralTerms;
